// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IQuestionsResponse } from './IQuestionsResponse';
import {
    IQuestionsResponseFromJSON,
    IQuestionsResponseFromJSONTyped,
    IQuestionsResponseToJSON,
    IQuestionsResponseToJSONTyped,
} from './IQuestionsResponse';

/**
 * 
 * @export
 * @interface ICipIdologyResponseDto
 */
export interface ICipIdologyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ICipIdologyResponseDto
     */
    status?: ICipIdologyResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ICipIdologyResponseDto
     */
    id_scan_url?: string;
    /**
     * 
     * @type {IQuestionsResponse}
     * @memberof ICipIdologyResponseDto
     */
    questions?: IQuestionsResponse;
    /**
     * 
     * @type {string}
     * @memberof ICipIdologyResponseDto
     */
    error?: string;
}

/**
* @export
* @enum {string}
*/
export enum ICipIdologyResponseDtoStatusEnum {
    PASS = 'PASS',
    FAIL = 'FAIL',
    QUESTIONNAIRE = 'QUESTIONNAIRE',
    CHALLENGE = 'CHALLENGE',
    ID_SCAN = 'ID_SCAN',
    PENDING = 'PENDING'
}


/**
 * Check if a given object implements the ICipIdologyResponseDto interface.
 */
export function instanceOfICipIdologyResponseDto(value: object): value is ICipIdologyResponseDto {
    return true;
}

export function ICipIdologyResponseDtoFromJSON(json: any): ICipIdologyResponseDto {
    return ICipIdologyResponseDtoFromJSONTyped(json, false);
}

export function ICipIdologyResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICipIdologyResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'id_scan_url': json['id_scan_url'] == null ? undefined : json['id_scan_url'],
        'questions': json['questions'] == null ? undefined : IQuestionsResponseFromJSON(json['questions']),
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function ICipIdologyResponseDtoToJSON(json: any): ICipIdologyResponseDto {
    return ICipIdologyResponseDtoToJSONTyped(json, false);
}

export function ICipIdologyResponseDtoToJSONTyped(value?: ICipIdologyResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'id_scan_url': value['id_scan_url'],
        'questions': IQuestionsResponseToJSON(value['questions']),
        'error': value['error'],
    };
}

